import { cloneDeep, get, size } from 'lodash';

import { chargersInfoTableId, chargersListDefaultSorting } from '../../../screens/ChargersList/components/ChargersList';
import { dashboardDefaultSorting, dashboardTableId } from '../../../screens/Dashboard/component';
import { multiFwDefaultSorting, multiFwUpdateTableId } from '../../../screens/MultiFwUpdate/constants';
import { plazaChargersDefaultSorting, plazaChargersTableId } from '../../../screens/PlazaView/components/PlazaChargerList/component';
import { shouldClearAdvancedSearchStateOnRouteChange } from '../../services/checkRouteChangesUtils';
import { chargersMultiselectFilter } from './component';
import { emptyQuery } from '../AdvancedSearch/QueryBuilder/constants';

const initListState = {
  isFetching: false,
  forceUpdate: false,
  page_token: 0,
  page_size: 20,
  filter: null,
  filterQuery: emptyQuery,
  sorting: null,
  totalCount: 0,
  data: [],
  selectedDataIds: [],
  selectAll: false,
  appliedQuery: emptyQuery,
  isExporting: false,
};

function ssplists(state = {}, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return {};

    case 'INIT_SSPLIST': {
      // TODO: refactor later!!!
      if (!state[action.id]) {
        return {
          ...state,
          [action.id]: {
            ...initListState,
            page_size: action.defaultPageSize,
            sorting: action.defaultSorting,
            forceUpdate: true,
          },
        };
      }

      const sspListInitState = {
        ...state[action.id],
        page_size: action.defaultPageSize,
        forceUpdate: true,
        isExporting: false,
      };

      if (!state[action.id].sorting) {
        sspListInitState.sorting = action.defaultSorting;
      }

      return { ...state, [action.id]: sspListInitState };
    }

    case 'LIST_REQUEST':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          isFetching: true,
          forceUpdate: false,
          data: [],
          error: null,
        },
      };

    case 'SET_LIST_EXPORTING': {
      const {
        payload: { id, isExporting },
      } = action;

      return { ...state, [id]: { ...state[id], isExporting } };
    }

    case 'LIST_REQUEST_SUCCESS':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          data: action.data,
          isFetching: false,
          forceUpdate: false,
        },
      };

    case 'LIST_REQUEST_ERROR':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          error: action.error,
          isFetching: false,
          forceUpdate: false,
        },
      };

    case 'LIST_CLEAR_DATA':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          isFetching: false,
          forceUpdate: false,
          page_token: 0,
          totalCount: 0,
          data: [],
          selectedDataIds: [],
          selectAll: false,
        },
      };

    case 'CHANGE_PAGE_OR_SIZE':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          page_token: action.page_token,
          page_size: action.page_size,
        },
      };

    case 'CHANGE_FILTER':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          filter: action.filter,
          page_token: 0,
        },
      };

    case 'CHANGE_FILTER_QUERY':
      return { ...state, [action.id]: { ...state[action.id], filterQuery: action.filterQuery } };

    case 'CHANGE_SORTING':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          sorting: action.sorting,
          page_token: 0,
        },
      };

    case 'HISTORY_LOCATION_CHANGE': {
      const { previousPathname } = action;
      const { pathname } = action;
      let stateToModify = {};

      if (shouldClearAdvancedSearchStateOnRouteChange(previousPathname, pathname)) {
        const defaultSortingMap = {
          [chargersInfoTableId]: chargersListDefaultSorting,
          [multiFwUpdateTableId]: multiFwDefaultSorting,
          [plazaChargersTableId]: plazaChargersDefaultSorting,
          [dashboardTableId]: dashboardDefaultSorting,
        };

        stateToModify = [chargersInfoTableId, multiFwUpdateTableId, plazaChargersTableId, dashboardTableId].reduce((acc, tableId) => {
          if (state[tableId]) {
            acc = {
              ...acc,
              [tableId]: {
                ...state[tableId],
                page_token: 0,
                page_size: 20,
                sorting: defaultSortingMap[tableId],
                filter: null,
                filterQuery: emptyQuery,
                appliedQuery: emptyQuery,
              },
            };
          }

          return acc;
        }, {});
      }

      return size(stateToModify) ? { ...state, ...stateToModify } : state;
    }

    case 'SET_ADVANCED_SEARCH_QUERY':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          appliedQuery: action.query,
          filter: null,
          page_token: 0,
        },
      };

    case 'SET_TOTAL_COUNT':
      return { ...state, [action.id]: { ...state[action.id], totalCount: action.count } };

    case 'SET_FORCE_UPDATE':
      return { ...state, [action.id]: { ...state[action.id], forceUpdate: true } };

    case 'RESET_PAGE':
      return { ...state, [action.id]: { ...state[action.id], page_token: 0 } };

    case 'SSP_TOGGLE_SELECT_ALL': {
      const selectAll = !state[action.id].selectAll;

      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          selectAll,
          selectedDataIds: selectAll ? state[action.id].selectedDataIds : [],
        },
      };
    }

    case 'SSP_SELECT_ALL':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          selectAll: true,
          selectedDataIds: [],
        },
      };

    case 'SSP_CLOSE':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          filterQuery: state[action.id].appliedQuery,
        },
      };

    case 'SSP_SELECT_ALL_CURRENT_PAGE':
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          selectAll: false,
          selectedDataIds: state[action.id].data.map((item) => (chargersMultiselectFilter.includes(action.id) ? item.c_uuid : item.uuid)),
        },
      };

    case 'SSP_DESELECT_ALL': {
      if (state[action.id]) {
        return {
          ...state,
          [action.id]: {
            ...state[action.id],
            selectAll: false,
            selectedDataIds: [],
          },
        };
      }

      return state;
    }

    case 'SSP_SET_ACTIVE_ITEM': {
      const stateSelectedDataIds = state[action.id].selectedDataIds || [];
      const selected = stateSelectedDataIds.includes(action.itemId);
      const selectedDataIds = selected
        ? stateSelectedDataIds.filter((id) => id !== action.itemId)
        : [...stateSelectedDataIds, action.itemId];

      return { ...state, [action.id]: { ...state[action.id], selectedDataIds } };
    }

    case 'RECALCULATE_SORT_FILTER_WITH_COLUMNS': {
      const { columns } = action;

      columns.unshift('c_uuid_contains');
      const stateById = state[action.id];
      const sortingToReturn = columns.includes(get(stateById, 'sorting.id'))
        ? stateById.sorting
        : {
            id: columns[0],
            desc: false,
          };
      const filterToReturn = size(stateById.filter)
        ? stateById.filter.map((field) => (columns.includes(field.id) ? field : null)).filter((field) => !!field)
        : [];

      return {
        ...state,
        [action.id]: {
          ...state[[action.id]],
          sorting: sortingToReturn,
          filter: filterToReturn,
          forceUpdate: true,
        },
      };
    }

    case 'ADD_OR_UPDATE_ITEM': {
      const newData = cloneDeep(state[action.id].data);
      const updatedItemIndex = newData.findIndex((item) => item[action.accessor] === action.item[action.accessor]);

      if (updatedItemIndex !== -1) {
        newData[updatedItemIndex] = action.item;
      } else {
        newData.push(action.item);
      }

      return { ...state, [action.id]: { ...state[action.id], data: newData } };
    }

    default:
      return state;
  }
}

export default ssplists;
